import { homeConstants } from "../constants";

const initialState = {
    reports: {
        loading: false,
        error: null,
        e_commerce: {}
    },
    users: {
        list: [],
        loading: false,
        error: false,
    },
    socket: null
};

export function home(state = initialState, action) {
    switch (action.type) {
        case homeConstants.GET_REPORT_E_COMMERCE_REQUEST:
            return {
                ...state,
                reports: {
                    ...state.reports,
                    loading: true,
                }
            };
        case homeConstants.GET_REPORT_E_COMMERCE_SUCCESS:
            return {
                ...state,
                reports: {
                    e_commerce: action.data,
                    loading: false,
                }
            };
        case homeConstants.GET_REPORT_E_COMMERCE_FAILURE:
            return {
                ...state,
                reports: {
                    e_commerce: [],
                    error: action.error,
                    loading: false,
                }
            };
        case homeConstants.GET_ALL_EMPLOYER_USER_LIST_REQUEST:
            return {
                ...state,
                users: {
                    ...state.users,
                    loading: true,
                }
            };
        case homeConstants.GET_ALL_EMPLOYER_USER_LIST_SUCCESS:
            return {
                ...state,
                users: {
                    ...state.users,
                    list: action.data,
                    loading: false,
                }
            };
        case homeConstants.GET_ALL_EMPLOYER_USER_LIST_FAILURE:
            return {
                ...state,
                users: {
                    ...state.users,
                    error: action.error,
                    loading: true,
                }
            };
        case homeConstants.SET_SOCKET:
            return {
                ...state,
                socket: action.socket
            };
        case homeConstants.CLEAR_SOCKET:
            return {
                ...state,
                socket: null
            };
        default:
            return state;
    }
}